import React from 'react';
import './Home.css';

export default function Solutions() {
  return (
    <div className="simple-page">
      <div className="page-inner">

        <p className="section-label">SOLUTIONS</p>

        {/* ===== Hero ===== */}
        <h2>Powering <span className="green-text">Sustainable</span> Infrastructure</h2>

        {/* ===== 01 What We Do ===== */}
        <div className="solutions-block">
          <h2>
            01 What We Do
          </h2>

          <p className="section-text">
            We deliver integrated investment solutions across renewable energy and
            infrastructure assets. Our approach combines disciplined capital deployment,
            structured financing, and active asset management to generate stable and
            sustainable returns.
          </p>
        </div>

        {/* ===== 02 Core Solutions ===== */}
        <div className="solutions-block">
          <h2>
            02 Core Solutions
          </h2>

          <div className="three-column-grid">

            <div className="info-panel">
              <h3>Renewable Energy Investment</h3>
              <p>
                Investment in solar, wind, and fuel cell assets across the full lifecycle
                — from development to operation — targeting long-term stable cash flows.
              </p>
            </div>

            <div className="info-panel">
              <h3>Infrastructure Financing</h3>
              <p>
                Structuring senior and mezzanine financing solutions for energy and
                infrastructure projects, enabling efficient capital deployment.
              </p>
            </div>

            <div className="info-panel">
              <h3>Asset Acquisition</h3>
              <p>
                Acquisition of operating infrastructure assets with strong fundamentals,
                followed by active management to enhance value and optimize returns.
              </p>
            </div>

            <div className="info-panel">
              <h3>Energy Transition</h3>
              <p>
                Investment in next-generation energy systems including hydrogen, fuel
                cells, and distributed energy solutions aligned with ESG principles.
              </p>
            </div>

            <div className="info-panel">
              <h3>Strategic Partnerships</h3>
              <p>
                Collaboration with developers, financial institutions, and industrial
                partners to create scalable and sustainable investment platforms.
              </p>
            </div>

          </div>
        </div>

        {/* ===== 03 Strategy (기존 유지) ===== */}
        <div className="solutions-block">
          <h2>
            03 Strategy
          </h2>

          <p className="section-text">
            LEEJIN Investment focuses on infrastructure sectors that generate stable
            cash flows and show relatively low sensitivity to market fluctuations.
            In response to demand driven by carbon neutrality and RE100, we identify
            renewable energy projects within the infrastructure industry and engage
            throughout the entire project lifecycle — from development and financing
            to disciplined execution and responsible management.
          </p>
        </div>

        {/* ===== 04 Investment Process ===== */}
        <div className="solutions-block">
  <h2>
    04 Investment Process
  </h2>

  <div className="strategy-visual-box">
    <div className="strategy-line" />
    <div className="strategy-center-text">INVESTMENT PROCESS</div>
    <div className="strategy-line" />
  </div>

  <div className="process-grid">

    <div className="process-card">
      <div className="process-step">01</div>
      <h3>Sourcing</h3>
      <p>
        Identify high-quality infrastructure and renewable energy investment opportunities
        through proprietary networks and market analysis.
      </p>
    </div>

    <div className="process-card">
      <div className="process-step">02</div>
      <h3>Structuring</h3>
      <p>
        Design optimal capital structures including equity, senior, and mezzanine financing
        tailored to each project's risk-return profile.
      </p>
    </div>

    <div className="process-card">
      <div className="process-step">03</div>
      <h3>Execution</h3>
      <p>
        Execute transactions with disciplined underwriting, due diligence, and risk management
        frameworks.
      </p>
    </div>

    <div className="process-card">
      <div className="process-step">04</div>
      <h3>Asset Management</h3>
      <p>
        Actively manage assets to enhance operational efficiency, cash flow stability,
        and long-term value creation.
      </p>
    </div>

    <div className="process-card">
      <div className="process-step">05</div>
      <h3>Exit</h3>
      <p>
        Optimize exit strategies through refinancing, partial divestment, or full exit
        to maximize investor returns.
      </p>
    </div>

  </div>
</div>
      </div>
    </div>
  );
}